import Vue from "vue";
import VueRouter from "vue-router";

import store from "../store/index";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/redirector");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: require("@/views/Home.vue").default,
  },
  {
    path: "/projects",
    name: "Projects",
    component: require("@/views/projects/projects.vue").default,
  },
  {
    path: '/viewMore/:uuid/:type',
    name: 'viewMore',
    component: () => import('@/views/view_more.vue'),
    props: (route) => {
      return {
        ...route.params, 
      };
    },
  },

  {
    path: "/publications",
    name: "Publications",
    component: require("@/views/publication/Publication.vue").default,
  },
  {
    path: '/ipbsl',
    name: 'IPBiosafetyLaws',
    component: require("@/views/ip-biosafety-law/laws.vue").default,
  },
  {
    path: '/media',
    name: 'Media',
    component: require("@/views/media/media.vue").default,
  },
  {
    path: '/search',
    name: 'search',
    component: require("@/views/search/Search.vue").default,
  },
  {
    path: '/faqs',
    name: 'faqs',
    component: require("@/views/faqs/faq.vue").default,
  },
  {
    path: '/opportunities',
    name: 'opportunities',
    component: require("@/views/opportunities/opportunities.vue").default,
  },
  {
    path: '/blogs',
    name: 'blogs',
    component: require("@/views/blogs/blogs.vue").default,
  },
  {
    path: "/redirector",
    name: "Redirector",
    component: require("@/views/Redirector.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: require("@/views/admin/dashboard.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/user",
    name: "List Users",
    component: require("@/views/admin/users/List.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/user/edit/:id",
    name: "Edit User",
    component: require("@/views/admin/users/EditUserDetails.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/user/roles/:id",
    name: "Edit User Roles",
    component: require("@/views/admin/users/EditUserRoles.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/user/show/:id",
    name: "Show User",
    component: require("@/views/admin/users/Show.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/user/create",
    name: "Create User",
    component: require("@/views/admin/users/Create.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/profile",
    name: "Profile",
    component: require("@/views/admin/profile.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/item-manager",
    name: "Item Manager",
    component: require("@/views/admin/items.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/workflow",
    name: "Workflow Manager",
    component: require("@/views/admin/workflow/workflow.vue").default,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/workflowsteps",
    name: "workflowstepsView",
    component: require("@/views/admin/workflow/workflownextsteps.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/workflownodes",
    name: "workflownodesView",
    component: require("@/views/admin/workflow/workflownodes.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/workflowcondition",
    name: "workflowconditionView",
    component: require("@/views/admin/workflow/workflowstepconditions.vue")
      .default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/workflowactionlog",
    name: "workflowactionlogView",
    component: require("@/views/admin/workflow/workflowactionlog.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/permission",
    name: "List Permissions",
    component: require("@/views/admin/permissions/List.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/permission/create",
    name: "Create Permission",
    component: require("@/views/admin/permissions/Create.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/permission/edit/:id",
    name: "Edit Permission",
    component: require("@/views/admin/permissions/Edit.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/role",
    name: "List Roles",
    component: require("@/views/admin/roles/List.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/role/create",
    name: "Create Role",
    component: require("@/views/admin/roles/Create.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/role/edit/:id",
    name: "Edit Role",
    component: require("@/views/admin/roles/Edit.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/role/show/:id",
    name: "Show Role",
    component: require("@/views/admin/roles/Show.vue").default,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/admin/faq",
    name: "Admin Faq",
    component: require("@/views/admin/faq/index.vue").default,
    beforeEnter: ifAuthenticated
  }
];

const router = new VueRouter({
  routes,
});

export default router;
